import React from 'react';

import PropTypes from 'prop-types';

import { LightButton } from 'apps/promo/components/common/fromAuth/LightButton/LightButton';
import { LightDiskBadge } from 'apps/promo/components/common/fromAuth/LightDiskBadge/LightDiskBadge';
import { LightNavBar } from 'apps/promo/components/common/fromAuth/LightNavBar/LightNavBar';
import LogoPurple from 'apps/promo/components/common/logo-purple/LogoPurple';
import { PromoText } from 'apps/promo/components/common/promo-text/PromoText';
import { PromoRow } from 'apps/promo/components/common/PromoRow/PromoRow';
import { PromoSectionContainer } from 'apps/promo/components/common/PromoSectionContainer';
import { REGISTRATION } from 'apps/promo/constants/UrlConstants';

import styles from './ReqAndMoneyInfo.module.css';

const ReqAndMoneyInfo = (props) => {
    const { extra } = props;
    const { avatar, country_code, headerText, currencyCode, comment, formatedAmount, promo_text, continueWeb, downloadLink, getApp, fromFi } = extra;
    const firstLetter = extra.fromName[0];

    return (
        <>
            <LightNavBar align="left">
                <LogoPurple whiteColor />
            </LightNavBar>
            <div className={styles.infoHeroBlock}>
                <PromoSectionContainer>
                    <PromoRow textAlign={'center'} indent={'32px'}>
                        <LightDiskBadge src={avatar ? avatar : null} diskText={!avatar ? firstLetter : null} flagName={country_code} diskSize={'x-large'} />
                    </PromoRow>
                    <PromoRow indent={'32px'}>
                        <PromoRow indent={'4px'}>
                            <PromoText tag={'div'} variant={'subheader'} color={'white'} textAlign={'center'}>
                                {`${headerText} ${fromFi}`}
                            </PromoText>
                        </PromoRow>
                        <PromoRow indent={'8px'}>
                            <PromoText tag={'div'} variant={'h1'} color={'white'} textAlign={'center'}>
                                {formatedAmount + ' '}
                                <PromoText tag={'span'} variant={'h1'} color={'white'} smallCaps>
                                    {currencyCode.toLowerCase()}
                                </PromoText>
                            </PromoText>
                        </PromoRow>
                    </PromoRow>
                    {comment && (
                        <PromoRow indent={'32px'}>
                            <PromoText tag={'div'} variant={'subheader'} color={'whiteRgba48'} textAlign={'center'}>
                                {comment}
                            </PromoText>
                        </PromoRow>
                    )}
                    <PromoRow indent={'56px'}>
                        <PromoText tag={'div'} variant={'subheader'} color={'white'} textAlign={'center'}>
                            {promo_text}
                        </PromoText>
                    </PromoRow>
                    <PromoRow textAlign={'center'} indent={'16px'}>
                        <LightButton variant={'primary'} type="link" href={downloadLink} caption={getApp} target="_blank" />
                    </PromoRow>
                    <PromoRow textAlign={'center'}>
                        <LightButton variant={'tertiary'} type="link" caption={continueWeb} href={REGISTRATION} />
                    </PromoRow>
                </PromoSectionContainer>
            </div>
        </>
    );
};

ReqAndMoneyInfo.propTypes = {
    extra: PropTypes.object.isRequired,
};

export default ReqAndMoneyInfo;
